module.exports = __webpack_public_path__ + "img/failed.e223194f.png";